/* created by CoolGuy on 2018/12/15 */
import React from 'react';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { debounce } from '../../utils/util';
import Special from './Special';
import ForShow from './ForShow';
import { withRouter } from 'react-router-dom';

@withRouter
@inject('rootStore')
@observer
class RedPackModalList extends React.Component {
  checkCurrentIsSpecial = (one, serverTime) => {
    const { posttype, posttime } = one;
    if (posttype === 'now') {
      return true; // 立即领取的红包
    }
    // 如果获取到了服务器时间，并且posttime已经超过了当前时间了，可以领取
    if (posttype === 'target' && posttime - serverTime < 0 && serverTime) {
      return true;
    }
    return false;
  };
  askRedPack = debounce(() => {
    const { redPackStore } = this.props.rootStore;
    redPackStore.askNGot();
  });

  // 注意，noticestep相关的数据需要到ForShow组件里边去处理
  @computed get filteredList() {
    // 需要根据后端返回的notice去筛选，只有 当前的时间差小于notice之后才显示出来
    const {
      redPackList = [],
      currentServerTime
    } = this.props.rootStore.redPackStore;
    return redPackList.filter(one => {
      const { posttime, notice, posttype } = one;
      // 立即发送的 是oK的
      if (posttype === 'now') {
        return true;
      }
      if (posttype === 'target') {
        //notice==0表示任何时间点打开都是显示出来的，不为0时再做判断
        if (+notice === 0) {
          return true;
        }
        if (posttime - currentServerTime <= notice) {
          return true;
        }
      }
      return false;
    });
  }

  closeSpecial = () => {
    const { redPackStore } = this.props.rootStore;
    redPackStore.removeOneRedPackList();
  };
  closeForShow = () => {
    const { redPackStore } = this.props.rootStore;
    redPackStore.removeAllRedPackList();
  };
  componentWillUnmount() {
    // console.log('redpack modal list unmount');
    // 卸载时因为redPackStore数据没有清空，会导致
    // 如果从评论中选择一条红包进入到/redpack/:id 页面再返回时， redPackList还存在，使用老的数据
    // 能够看到红包先闪了一下，然后数据获取完成后就消失了，所以这里直接清空一下，反正都unmount了
    const { redPackStore } = this.props.rootStore;
    redPackStore.clearAll();
  }

  render() {
    const { currentServerTime } = this.props.rootStore.redPackStore;
    // 注意，对于Special来说，每次都是只取得0号元素展示
    const one = this.filteredList.slice()[0];
    if (!one) {
      return null;
    }
    // console.log('here',one);
    if (this.checkCurrentIsSpecial(one, currentServerTime)) {
      return (
        <Special
          {...one}
          onSubmit={this.askRedPack}
          onClose={this.closeSpecial}
        />
      );
    }
    // console.log(this.filteredList.length,'render length')

    return <ForShow list={this.filteredList} onClose={this.closeForShow} />;
  }
}

export default RedPackModalList;
